import { createAction, props } from '@ngrx/store';
import { ApplicationSearchState } from 'src/app/applications/application-filter-form/application-filter-form.component';
import { HiveApplication } from 'src/app/applications/hive-application';

export const fetchHiveApplications = createAction('[applications] fetch');

export const getHiveApplicationsSuccess = createAction(
  '[applications] get hive applications success',
  props<{ applications: HiveApplication[] }>()
);
export const getHiveApplicationsError = createAction(
  '[applications] get hive applications failed',
  props<{ error: any }>()
);

export const updateItemUsesTableFilter = createAction(
  '[applications] update item uses table filter',
  props<{ tableFilter: ApplicationSearchState }>()
);
